<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" @rightClick="onAddNewClass" />
    <div class="topRect" :style="'background: linear-gradient(left bottom,'+GetColorMainGradual()+','+GetColorMain()+');background: -webkit-linear-gradient(left bottom,'+GetColorMainGradual()+','+GetColorMain()+');'">
      <div class="info">
        <van-row>
          <van-col span="20">关联账号:
            <span v-if="accountData && accountData.accountName">{{ accountData.accountName }}</span>
            <span v-if="!accountData || !accountData.accountName" @click="showBind=true">立即绑定</span>
          </van-col>
          <van-col span="4" class="rigth"><i class="iconfont iconsetting" @click="showBind=true" /></van-col>
        </van-row>
        <van-row>
          <van-col span="24">最后刷新:
            {{ accountData && accountData.lastUpdateTime?formatDate(accountData.lastUpdateTime,"yyyy/MM/dd hh:mm:ss",true):'-' }}
            <i v-if="accountData && accountData.lastUpdateTime" class="iconfont iconrotate" @click="onReloadAida" />
          </van-col>
        </van-row>
      </div>
    </div>
    <van-skeleton :loading="loading" :row="20">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in classList" :key="item.course.aidaClassId" class="listRect">
          <van-row @click="onViewClass(item.course.aidaClassId)">
            <van-col span="14" class="title">{{ item.course.address }}</van-col>
            <van-col span="10" class="rigth">
              <span class="date">{{ formatDate(item.course.startDate,"yyyy/MM/dd") }}</span>
              <van-tag :color="GetColorMain()">{{ item.course.level }}</van-tag>
            </van-col>
          </van-row>
          <div class="title" @click="onViewClass(item.course.aidaClassId)">{{ item.course.title }}</div>
          <div class="studentRect">
            <van-row v-for="student in item.students" :key="student.studentId" class="studentLine">
              <van-col span="16" @click="onViewClass(item.course.aidaClassId)"><i class="iconfont iconwode" /> {{ student.name?student.name:student.emailAddress }}</van-col>
              <van-col span="8" class="rigth">{{ student.status }}
                <i v-if="student.haveCertificate" class="iconfont iconaidajiangpai" @click="onViewCertificate(student.certificateId)" />
              </van-col>
            </van-row>
          </div>
        </div>
      </van-list>
    </van-skeleton>

    <van-popup v-model="showBind" class="bindForm">
      <TopBar pagetitle="关联AIDA账号" :is-left-self="true" @leftClick="onCloseBind" />
      <div class="inputRect">
        <van-field
          v-model="accountForm.account"
          required
          clearable
          label="账号"
          placeholder="请输入Aida系统教练登陆邮箱"
        />
        <van-field
          v-model="accountForm.password"
          required
          clearable
          label="验证码"
          placeholder="请输入Aida系统教练登陆密码"
        />

        <div class="buttonRect">
          <van-button type="primary" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onBindAida">关联Aida账号</van-button>
        </div>
      </div>
      <div class="regAbout">
        1.我们将严格保护您的第三方账号密码安全，通过AES算法进行加密您的私密信息；<br>
        2.关联Aida账号可以在平台直接操作关联的Aida账号,方便专业人士使用；<br>
        3.因Aida系统不稳定,可能导致服务无法正常使用。如出现故障无法使用请联系客服反馈。
      </div>
    </van-popup>
    <adiaClassAdd v-model="showAddClass" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Tag, Toast, Dialog, Skeleton, List, Popup, Field, Button } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainGradual, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import adiaClassAdd from '@/views/pro/aida/adiaClassAdd'
export default {
  components: {
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Skeleton.name]: Skeleton,
    [List.name]: List,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Button.name]: Button,
    TopBar,
    adiaClassAdd
  },
  data() {
    return {
      titleTop: '',
      title: 'AIDA辅助管理',
      backurl: '/store/index',
      accountData: {

      },
      showBind: false,
      buttonLoading: false,
      accountForm: {
        account: undefined,
        password: undefined
      },
      classList: [],
      loading: false,
      finished: false,
      search: {
        limit: 30,
        page: 1
      },
      showAddClass: false
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.initAccount()
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainGradual,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    initAccount() {
      request({
        url: '/Pro/CheckAccountSuccess',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.accountData = response.data
        if (this.accountData) {
          this.accountForm.account = this.accountData.accountName
        } else {
          this.accountForm.account = undefined
        }

        if (this.accountForm.account) {
          this.onLoad()
        } else {
          Dialog.confirm({
            title: '是否关联AIDA账号?',
            message: '关联Aida账号可以在平台直接操作关联的Aida账号,方便专业人士使用'
          })
            .then(() => {
              this.showBind = true
            })
        }
      })
    },
    onCloseBind() {
      this.showBind = false
      return true
    },
    onAddNewClass() {
      if (!this.accountData.accountName) {
        MyNotify('error', '关联账号后才可以添加')
        return
      }
      this.showAddClass = true
    },
    onBindAida() {
      if (!this.accountForm.account) {
        MyNotify('error', '请输入需要关联的账号')
        return
      } if (!this.accountForm.password) {
        MyNotify('error', '请输入密码')
        return
      }
      this.buttonLoading = true
      request({
        url: '/Pro/SetAidaAccount',
        method: 'post',
        data: this.accountForm
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '关联成功')
        this.initAccount()
        this.onReloadAida()
        this.showBind = false
      })
    },
    onLoad() {
      if (!this.accountData.accountName) {
        return
      }
      console.log('onLoad')
      this.loading = true
      request({
        url: '/Pro/getAidaClassList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.classList.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onReloadAida() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在与AIDA同步数据中(1分钟左右)，请耐心等待!'
      })

      request({
        url: '/Pro/ReloadAida',
        method: 'post'
      }).then(response => {
        Toast.clear()
        if (!response.success) {
          return
        }
        MyNotify('success', '刷新数据成功')
        this.classList = []
        this.loading = false
        this.finished = false
        this.search = {
          limit: 30,
          page: 1
        }
        this.onLoad()
      })
    },
    onViewCertificate(certificateId) {
      MyNotify('info', '证书编码:' + certificateId + ',暂不支持证书预览')
    },
    onViewClass(id) {
      this.$router.push('/pro/aidaClass/' + id)
    }
  }
}
</script>
<style scoped>
.topRect{
  color: #fff;
  padding: 0.5em 1.5em;
}
.topRect .info{
  font-size: 0.8em;
  padding: 0.5em 0;
  line-height: 1.8em;
}
.bindForm{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.bindForm .inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.bindForm .regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
  line-height: 1.6em;
}

.listRect{
  padding: 0.5em 1em;
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
}
.listRect .title{
  font-size: 0.8em;
}
.listRect .date{
  color: #999;
  font-size: 0.8em;
  margin-right: 0.5em;
}
.studentRect{
  font-size: 0.8em;
  margin-top: 0.5em;
}
.studentRect .studentLine{
  padding: 0.25em 0;
}
</style>
